import { graphql } from 'react-relay';

export const CheckoutChargeAdd = graphql`
  mutation CheckoutChargeAddMutation($input: CheckoutChargeAddInput!) {
    CheckoutChargeAdd(input: $input) {
      charge {
        id
        paymentLinkUrl
      }
      error
      success
    }
  }
`;
